import { useState } from "react";
import styles from "./footer.module.scss";
import { NavLink, useLocation } from "react-router-dom";
import { FooterProps } from "../../interfaces/components";
import { useWindowSize } from "use-hooks";
import { images } from "../../constants/images";
import { AnalyticsService } from "../../helpers/analytics";
import TermsModalContainer from "../../containers/TermsModal/TermsModalContainer";
import { useAuthModal } from "../../context/AuthModalContext";

const FooterComponent = ({
    user,
    searchType,
    setTypeReducer
}: FooterProps) => {
    const location = useLocation();
    const windowSize = useWindowSize();
    const [termsModalOpen, setTermsModalOpen] = useState<boolean>(false);
    const { handleOpenAuthModal } = useAuthModal();

    const handleOpenTermsModal = () => {
        setTermsModalOpen(true);
    }

    const handleCloseTermsModal = () => {
        setTermsModalOpen(false);
    }

    const handlePressFilter = (value: string) => {
        if(value === ""){
            setTypeReducer([]);
            return;
        }
        if(value === 'van' || value === 'deportivo') setTypeReducer([]);
        else setTypeReducer([value]);
    }

    return (
        <footer className={styles.footerContainer}>
            <section className={styles.footerContent}>
                <div className={styles.leftFooter}>
                    <img src={images.isoLogoTipo} alt="iso logo" title="iso logo"/>
                    <p style={{color: "#595959", fontSize:  windowSize.width < 1024 ? "15px" : "16px", margin: "12px 0"}}>Un producto de Linzecar SPA®.</p>
                </div>
                <div className={styles.rightFooter}>
                    <div className={styles.rowFooter}>
                        <div style={{display:  windowSize.width < 1024 ? "none" : "flex", flexDirection: "row", gap: "32px", alignItems: "center", position:  windowSize.width < 1024 ? "relative" : "absolute", right: 0, left: 0, justifyContent: "center", bottom: windowSize.width > 1412 ? "80px" : "88px"}}>
                            <NavLink to='/buscar/autos/usados' onClick={() => AnalyticsService.trackButtonClick('buy', 'footer')} className={styles.aLink}>
                                Comprar
                            </NavLink>
                            <NavLink to={'/vender-auto'} onClick={() => AnalyticsService.trackButtonClick('sell', 'footer')} className={styles.aLink}>
                                Vender
                            </NavLink>
                            <NavLink to={'/ingresar'} className={styles.aLink}>
                                Ingresar
                            </NavLink>
                        </div>
                        <div className={styles.socialNetworksContainer}>
                            <div onClick={() => window.open("https://www.instagram.com/linzecar.chile/","_blank")} className={styles.socialIconWrapper}>
                                <img src={images.instagramIconFooter2} className={styles.instagramIconFooter} alt="instagram logo" title="instagram logo"/>
                            </div>
                            <div onClick={() => window.open("https://www.facebook.com/Linzecar.chile/?locale=es_LA","_blank")} className={styles.socialIconWrapper}>
                                <img src={images.facebookIconFooter} className={styles.fbIconFooter} alt="facebook logo" title="facebook logo"/>
                            </div>
                            <div onClick={() => window.open("https://www.tiktok.com/@linzecar?_t=ZM-8ysIVHN42wq&_r=1","_blank")} className={styles.socialIconWrapper}>
                                <img src={images.tiktokIconFooter} className={styles.tiktokIconFooter} alt="tiktok logo" title="tiktok logo"/>
                            </div>
                            <div onClick={() => window.open("https://www.linkedin.com/company/linze-car/","_blank")} className={styles.socialIconWrapper}>
                                <img src={images.linkedinIcon} className={styles.linkedinIcon} alt="linkedin logo" title="linkedin logo"/>
                            </div>
                        </div>
                    </div>
                    <div  style={{display: "flex", flexDirection: windowSize.width > 1412 ? "row" : "column", gap: windowSize.width > 1412 ? "24px" :"6px", alignItems: "center", position: windowSize.width < 1024 ? "relative" : "absolute", right: 0, left: 0, justifyContent: "center", bottom: windowSize.width < 1024  ? 0 :"32px",}}>
                        <p style={{color: "#595959", fontSize:  windowSize.width < 1024 ? "12px" : "16px", textAlign:  windowSize.width < 1024 ? "center" : "unset" }}>Copyright © {new Date().getFullYear()} Linze. Todos los derechos reservados</p>
                        <p style={{color: "#595959", display: windowSize.width > 1412 ?"block" : "none"  }}>|</p>
                        <p style={{color: "#595959", fontSize:  windowSize.width < 1024 ? "12px" : "16px"}}>Visita nuestros <span onClick={handleOpenTermsModal}><u style={{fontWeight: "500", cursor: "pointer"}}>términos y condiciones</u></span></p>
                    </div>
                </div>
                {windowSize?.width < 1024 ? <div style={{width: "100%", height: "1px", backgroundColor: "#E2E8F0", margin: "16px 0 8px 0"}}/> : null}
            </section>
            <TermsModalContainer open={termsModalOpen} onClose={handleCloseTermsModal} />
        </footer>
    )
}
export default FooterComponent;